// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"6906":"c483695b1a70a94e","9068":"68318f35b538a702"}[chunkId] + ".css";
};